import { AutoCompleteService } from 'ionic2-auto-complete';
import { Http } from '@angular/http';
import { Injectable } from "@angular/core";

import { DOMAIN } from '../config';

@Injectable()
export class AutoComplete implements AutoCompleteService {
  labelAttribute = "nom";
  // labelAttribute = "name";
  
  constructor(private http:Http) {

  }

  getResults(keyword:string) {
    // On retire les accents et change le saint
    var accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
    var accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";

    for (var y = 0; y < keyword.length; y++) {
      if (accents.indexOf(keyword[y]) != -1) {
        keyword = keyword.substr(0, y) + accentsOut.substr(accents.indexOf(keyword[y]), 1) + keyword.substr(y+1, keyword.length);
      }
    }

    if ((keyword.toLowerCase()).indexOf("saint") !== -1) {
      keyword = keyword.replace(/saint/ig, 'St-');
    }

    // Mettre à jour visuelement sur le champ de recherche

    // On return les résultats
    return this.http.get(`//${DOMAIN}/api/gares/` + keyword)
      .map(
        result => {
          return result.json().filter(item => item.nom.toLowerCase())
        }
      );
  }
  // getResults(keyword:string) {
  //   return this.http.get("https://restcountries.eu/rest/v1/name/"+keyword)
  //     .map(
  //       result =>
  //       {
  //           console.log(result.json().filter(item => item.name.toLowerCase().startsWith(keyword.toLowerCase())));
  //         return result.json()
  //           .filter(item => item.name.toLowerCase().startsWith(keyword.toLowerCase()) )
  //       });
  // }
}